// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"BrandedModalHeader_closeButton__1xJx9","header":"BrandedModalHeader_header__3mPSH","logo":"BrandedModalHeader_logo__2YBne"};